import { ApiRequestOptions, request, RequestFn } from '#/helpers/ApiRequest';
import { useAuth0 } from '@auth0/auth0-react';

export const useRequest = (): RequestFn => {
  const { getAccessTokenSilently } = useAuth0();

  return (path: string, options: ApiRequestOptions) =>
    request(path, { ...options, getAccessToken: getAccessTokenSilently });
};
